import { useMemo } from 'react';
import { ApolloClient, HttpLink, ApolloLink } from '@apollo/client';
import { ApolloProvider } from '@apollo/client/react';
import { ErrorLink } from '@apollo/client/link/error';
import { CombinedGraphQLErrors, ServerError } from '@apollo/client';
import { createGraphqlCache } from './graphqlCache.js';

export default function GraphqlProvider({ children }) {
	const apolloClient = useMemo(() => buildApolloClient(), []);

	return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
}

function buildApolloClient() {
	const httpLink = new HttpLink({
		uri: window.location.origin + '/graphql',
		credentials: 'same-origin',
	});

	const errorLink = new ErrorLink(({ error, _result }) => {
		if (CombinedGraphQLErrors.is(error)) {
			error.errors.forEach(({ message, locations, path }) =>
				console.warn(
					`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
				)
			);
		} else if (ServerError.is(error)) {
			console.warn(`[Server error]: ${error.message}`);
		} else if (error) {
			console.warn(`[Other error]	: ${error.message}`);
		}
	});

	const cache = createGraphqlCache();

	return new ApolloClient({
		link: ApolloLink.from([errorLink, httpLink]),
		cache,
		defaultOptions: {
			watchQuery: {
				fetchPolicy: 'cache-and-network',

				/* Keep refetches from setting loading and hiding mounted content. */
				notifyOnNetworkStatusChange: false,
			},
		},
	});
}
